module.exports = __webpack_public_path__ + "media/images/tpl/mindmap-9e2866a27c0bffafda2119d9e0719dad.svg";